var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2)]), _c('div', {
    staticClass: "pagination"
  }), _c('v-btn', {
    staticClass: "prev-btn",
    attrs: {
      "icon": "",
      "large": "",
      "outlined": "",
      "color": "#dadada"
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow"
  })]), _c('v-btn', {
    staticClass: "next-btn",
    attrs: {
      "icon": "",
      "large": "",
      "outlined": "",
      "color": "#dadada"
    }
  }, [_c('i', {
    staticClass: "icon icon-right-arrow"
  })])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }